import api from '../httpClient';

export type PublicSettings = {
  support_email: string;
};

export const publicSettings = {
  get: () => api.get<PublicSettings>('/api/public/settings/'),
};
